/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { asyncConnect } from 'redux-connect';
import Tagging from '../../../../../components/Tagging';
import PredeterminedListsDetailsWeb from './PredeterminedListsDetailsWeb';
import PredeterminedListsDetailsWap from './PredeterminedListsDetailsWap';
import * as labelsActions from '../../../../../components/labels/actions';
import * as predeterminedListsActions from '../actions';
import commonUtil from '../../../../../utils/commonUtil';
import AppEvents from '../../../../App/AppEvents';

const channel = commonUtil.getChannel();
const { isLablesLoaded, loadLables } = labelsActions;
const {

  getaddPredeterminedItem,

  } = predeterminedListsActions;
@asyncConnect([{
  deferred: false,
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,

}),

  {
    ...labelsActions,
    ...predeterminedListsActions,
  })


class PredeterminedListsDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.wapBackButtonEvent = null;
    this.changeComponentOnBackButtonClick = this.changeComponentOnBackButtonClick.bind(this);
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.addPredeterminedItemButton && nextProps.addPredeterminedItemButton.predeterminedItemInfo && nextProps.addPredeterminedItemButton.predeterminedItemInfo.length >= 0) {

      // browserHistory.push('/SearchResult');
    }
  }
  // By OD commented
  /* getTaggingData = (repositoryId, eventId) => {
    const _dataLayer = {};
    _dataLayer.event = 'addPredeterminedLists';
    _dataLayer.category = 'addPredeterminedLists';
    const _addPredeterminedLists = {};
    _addPredeterminedLists.repositoryId = repositoryId;
    _addPredeterminedLists.eventId = eventId;
    _dataLayer.addPredeterminedLists = _addPredeterminedLists;

    return _dataLayer;
  } */
  handleAddListToMyList = (repoId,eventId,deliveryMode) => {
    this.props.getaddPredeterminedItem(repoId, this.props.params.eventID,deliveryMode);
    // By OD commented
    // const repositoryId = repoId;
    // const eventId = this.props.params.eventID;
    // const _dataLayer = this.getTaggingData(repositoryId, eventId);
    // this.tagging.applyGTM('addPredeterminedLists', _dataLayer);
  }
  componentDidMount() {
    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);

    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.changeComponentOnBackButtonClick]);
    }
  }
  changeComponentOnBackButtonClick = () => {
    window.history.back();
  }

  render() {
    const addPredeterminedItemInfo = this.props.addPredeterminedItemButton ? this.props.addPredeterminedItemButton.predeterminedItemInfo : null;
    const predeterminedLabels = this.props.lables;

    return (

      <div>
        <Tagging ref={tagging => this.tagging = tagging} />
        {channel && channel === 'web' ?
          <PredeterminedListsDetailsWeb
            {...this.props}
            onAddListToMyList={this.handleAddListToMyList}
            addPredeterminedItemInfo={addPredeterminedItemInfo}
            eventId={this.eventId}
            labels={predeterminedLabels}
          />
          :
          <PredeterminedListsDetailsWap
            {...this.props}
            onAddListToMyList={this.handleAddListToMyList}
            addPredeterminedItemInfo={addPredeterminedItemInfo}
            eventId={this.eventId}
            labels={predeterminedLabels}
          />}
      </div>

    );
  }

}
const mapStateToProps = state => ({
  myData: state,


  addPredeterminedItemButton: (state.predeterminedLists.data && state.predeterminedLists.data.addPredeterminedItemButton) ? state.predeterminedLists.data.addPredeterminedItemButton : null,

});
const matchDispatchToProps = dispatch => bindActionCreators({

  getaddPredeterminedItem,


}, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(PredeterminedListsDetails);

